// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/Response/Responses.css */

.responses-container {
  color: white;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  position: relative;
  width: 100%;
  height: 85vh;
  max-height: 85vh;
  padding: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* Header container for icon and title */
.headerr-container {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
}

.homeee-icon {
  width: 35px;
  height: 35px;
  margin-left: 1rem;
  transition: transform 0.2s ease;
  border-radius: 50%;
  border: 3px solid #364C63;  
  border-color: #EF6F53;  
  padding: 5px;
  position: absolute;
  left: 0;
  z-index: 1;
  margin-bottom: 5px;
  background-color: white;
}

.homeee-icon:hover {
  transform: scale(1.1);
  border-color: #aaa;  
}

.responses-title {
  color: #EF6F53;
  text-align: center;
  margin-top: 1rem;
  font-size: 1.5rem;
  flex-shrink: 0;
  font-weight: 700;
  width: 100%;
  margin-left: 0;
}

.error-message {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff6b6b;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 8px;
  text-align: center;
  flex-shrink: 0;
  font-size: 0.9rem;
}

.loading {
  text-align: center;
  padding: 10px;
  font-size: 1.1rem;
  color: #EF6F53;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-sectionn {
  background-color: #1e1e1e;
  padding: 6px;
  border-radius: 8px;
  margin-bottom: 6px;
  flex-shrink: 0;
  display: flex;
  gap: 8px;
}

.date-input {
  padding: 3px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 0.8rem;
  background-color: #253e5897;
  color: white;
  height: 24px;

}

.paginationn{
    margin-top: 1rem;
}

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #2a2a2a !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.conversation-modal {
  background-color: #ffffff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  height: 75vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  text-align: left;
}

.modal-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  color: #EF6F53;
  margin: 0;
  font-size: 1rem;
}

.close-button {
  background: none;
  border: none;
  color: #000000;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
  font-weight: 700;

}

.conversation-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.message {
  max-width: 70%;
  padding: 0.5rem;
  border-radius: 12px;
  position: relative;
  word-wrap: break-word;
}

.message.received {
  align-self: flex-start;
  background-color: #064384;
  color: white;
  border-bottom-left-radius: 4px;
}

.message.sent {
  align-self: flex-end;
  background-color: #EF6F53;
  color: white;
  border-bottom-right-radius: 4px;
}

.message-content {
  margin-bottom: 0.25rem;
}

.message-time {
  font-size: 0.7rem;
  opacity: 0.8;
  text-align: right;
}

.reply-section {
  padding: 0.5rem;
  display: flex;
  gap: 0.5rem;
}

.reply-input {
  flex: 1 1;
  padding: 0.5rem;
  border-radius: 20px;
  background-color: #6a7d9233;
  color: #364C63;
  font-size: 0.9rem;
}

.reply-input:focus {
  outline: none;
  border: 2px solid #EF6F53;
}

.send-button {
  background-color: #EF6F53;
  color: white;
  border: none;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.send-button:hover:not(:disabled) {
  background-color: #d45e45;
}

.send-button:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/Response/Responses.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,YAAY;EACZ,kDAAkD;EAClD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;;AAEd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;;AAElB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* src/components/routes/Forms/Response/Responses.css */\n\n.responses-container {\n  color: white;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  position: relative;\n  width: 100%;\n  height: 85vh;\n  max-height: 85vh;\n  padding: 8px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header container for icon and title */\n.headerr-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin-bottom: 2rem;\n}\n\n.homeee-icon {\n  width: 35px;\n  height: 35px;\n  margin-left: 1rem;\n  transition: transform 0.2s ease;\n  border-radius: 50%;\n  border: 3px solid #364C63;  \n  border-color: #EF6F53;  \n  padding: 5px;\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  margin-bottom: 5px;\n  background-color: white;\n}\n\n.homeee-icon:hover {\n  transform: scale(1.1);\n  border-color: #aaa;  \n}\n\n.responses-title {\n  color: #EF6F53;\n  text-align: center;\n  margin-top: 1rem;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  font-weight: 700;\n  width: 100%;\n  margin-left: 0;\n}\n\n.error-message {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: #ff6b6b;\n  padding: 5px;\n  border-radius: 5px;\n  margin-bottom: 8px;\n  text-align: center;\n  flex-shrink: 0;\n  font-size: 0.9rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 10px;\n  font-size: 1.1rem;\n  color: #EF6F53;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.filter-sectionn {\n  background-color: #1e1e1e;\n  padding: 6px;\n  border-radius: 8px;\n  margin-bottom: 6px;\n  flex-shrink: 0;\n  display: flex;\n  gap: 8px;\n}\n\n.date-input {\n  padding: 3px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  background-color: #253e5897;\n  color: white;\n  height: 24px;\n\n}\n\n.paginationn{\n    margin-top: 1rem;\n}\n\n.clickable-row {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.clickable-row:hover {\n  background-color: #2a2a2a !important;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.conversation-modal {\n  background-color: #ffffff;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  height: 75vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  position: relative;\n  text-align: left;\n}\n\n.modal-header {\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  color: #EF6F53;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  color: #000000;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.close-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  font-weight: 700;\n\n}\n\n.conversation-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.message {\n  max-width: 70%;\n  padding: 0.5rem;\n  border-radius: 12px;\n  position: relative;\n  word-wrap: break-word;\n}\n\n.message.received {\n  align-self: flex-start;\n  background-color: #064384;\n  color: white;\n  border-bottom-left-radius: 4px;\n}\n\n.message.sent {\n  align-self: flex-end;\n  background-color: #EF6F53;\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.message-content {\n  margin-bottom: 0.25rem;\n}\n\n.message-time {\n  font-size: 0.7rem;\n  opacity: 0.8;\n  text-align: right;\n}\n\n.reply-section {\n  padding: 0.5rem;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.reply-input {\n  flex: 1;\n  padding: 0.5rem;\n  border-radius: 20px;\n  background-color: #6a7d9233;\n  color: #364C63;\n  font-size: 0.9rem;\n}\n\n.reply-input:focus {\n  outline: none;\n  border: 2px solid #EF6F53;\n}\n\n.send-button {\n  background-color: #EF6F53;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.send-button:hover:not(:disabled) {\n  background-color: #d45e45;\n}\n\n.send-button:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
